var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 26.25H8.125C7.43464 26.25 6.875 25.6904 6.875 25V10.5178C6.875 10.1862 7.0067 9.8683 7.24112 9.63388L12.7589 4.11612C12.9933 3.8817 13.3112 3.75 13.6428 3.75H22.5C23.1904 3.75 23.75 4.30964 23.75 5V25C23.75 25.6904 23.1904 26.25 22.5 26.25Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8748 25.3748V4.62476H13.3819L7.12476 10.8819V25.3748H22.8748ZM12.6551 2.87476L5.37476 10.1551V24.9998C5.37476 26.1676 6.33186 27.1248 7.49976 27.1248H22.4998C23.6676 27.1248 24.6248 26.1676 24.6248 24.9998V4.99976C24.6248 3.83186 23.6676 2.87476 22.4998 2.87476H12.6551Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 15,
    width: 2.5,
    height: 8.125,
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 22.5251L9.25 22.5252C9.25022 23.1035 9.74344 23.5625 10.3362 23.5625H10.3365H19.6636C20.2565 23.5625 20.7498 23.1035 20.7498 22.5251L20.75 15.9124C20.75 15.334 20.2567 14.875 19.6638 14.875H10.3362C9.74347 14.875 9.25 15.334 9.25 15.9124L9.25 22.5251ZM10.1028 22.5251V19.4562H12.9564V22.7408H10.3367C10.2022 22.7408 10.1037 22.6388 10.1028 22.5265V22.5251ZM10.1031 18.6346V15.9124C10.1031 15.7994 10.202 15.6965 10.3368 15.6965L10.3368 15.6965H12.9565V18.6346H10.1031ZM17.0442 18.0943H19.898V20.3429H17.0442V18.0943ZM16.1918 22.7409H13.8088V15.6966H16.1918V22.7409ZM19.6639 22.7409H17.0442V21.1647H19.898V22.5252C19.898 22.6379 19.7991 22.7409 19.6639 22.7409ZM19.898 15.9124V17.2729L17.0442 17.2727V15.6965H19.6639C19.799 15.6965 19.898 15.7996 19.898 15.9124Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivation);
export default __webpack_public_path__ + "static/media/activation.b75fb9d2a14c18b9b5d543f7d626deac.svg";
export { ForwardRef as ReactComponent };